import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterDataAPI, filterTableDataAPI } from "../../services/CRUDServices";

export const filterSurveyDetail: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "sureveyDetail",
  async (body: any) => {
    let { data } = await filterDataAPI(
      `/customer-api/questionInstance/v1/s1/grid?pageNumber=${body.pageNumber}&pageSize=${body.pageSize || "10"}&surveyId=${body.surveyId}`,
      undefined,
      undefined,
      false,

    );

    console.log("data is",data)
    return { data:data.response };
  }
);

const initialState: any = {
  surveyDetailData: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const SurveyDetailSlice = createSlice({
  initialState: initialState,
  name: "sureveyDetail",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
    setFilterSurveyDetail: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterSurveyDetail.fulfilled as any]: (state, action) => {
      state.surveyDetailData = action.payload.data;
      state.fetchpost = false;
    },
    [filterSurveyDetail.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterSurveyDetail.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setFilterSurveyDetail } = SurveyDetailSlice.actions;
export default SurveyDetailSlice.reducer;
